export default __webpack_public_path__ + "static/media/VehicleInfo_Green.31bb68ed.png";